export class ModelM3Notif{
    public IdRep:string;
    public IDUbicacion:string;
    public IdHub:string;
    public Correr:string;
    public Tipo:number;
    public Condiciones:string;
    public Data:string;
    public ConfImp:string;
}